(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function counters(scope){
    var list = scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll('[data-count]')) : [];
    if(scope.hasAttribute && scope.hasAttribute('data-count')) list.push(scope);
    list.forEach(function(t){
      if(t.__c) return; t.__c=1;
      var to=parseFloat(t.getAttribute('data-count')), dec=parseInt(t.getAttribute('data-dec')||0,10), st=performance.now();
      (function step(now){ var p=Math.min(1,(now-st)/1500), e=1-Math.pow(1-p,3); t.textContent=(to*e).toFixed(dec); if(p<1) requestAnimationFrame(step); })(st);
    });
  }
  function reveal(){
    var nodes = document.querySelectorAll('.reveal');
    if(reduce || !('IntersectionObserver' in window)){ nodes.forEach(function(n){ n.classList.add('in'); counters(n); }); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); counters(e.target); io.unobserve(e.target); } }); }, {threshold:.14, rootMargin:'0px 0px -6% 0px'});
    nodes.forEach(function(n){ io.observe(n); });
  }
  function parallax(){
    if(reduce) return;
    var pars = Array.prototype.slice.call(document.querySelectorAll('[data-par]'));
    if(!pars.length) return;
    var tx=0,ty=0,cx=0,cy=0;
    window.addEventListener('mousemove', function(e){ tx=e.clientX-innerWidth/2; ty=e.clientY-innerHeight/2; });
    (function loop(){ cx+=(tx-cx)*.06; cy+=(ty-cy)*.06; pars.forEach(function(p){ var f=parseFloat(p.getAttribute('data-par')); p.style.transform='translate3d('+(cx*f).toFixed(2)+'px,'+(cy*f).toFixed(2)+'px,0)'; }); requestAnimationFrame(loop); })();
  }
  // Quiz
  function quiz(){
    var modal = document.getElementById('skin-quiz'); if(!modal) return;
    var steps = JSON.parse(modal.getAttribute('data-steps')||'[]');
    var recs = JSON.parse(modal.getAttribute('data-recs')||'{}');
    var state = { step:0, ans:{} };
    var qEl = modal.querySelector('[data-quiz-q]'), optsEl = modal.querySelector('[data-quiz-opts]'),
        barEl = modal.querySelector('[data-quiz-bar]'), stepEl = modal.querySelector('[data-quiz-step]'),
        resEl = modal.querySelector('[data-quiz-result]'), formEl = modal.querySelector('[data-quiz-form]');
    function render(){
      var done = state.step >= steps.length;
      barEl.style.width = Math.round(Math.min(state.step,steps.length)/steps.length*100)+'%';
      formEl.style.display = done?'none':'block'; resEl.style.display = done?'block':'none';
      if(done){ var key=state.ans[steps[0].key]||Object.keys(recs)[0]; var r=recs[key]||recs[Object.keys(recs)[0]];
        resEl.querySelector('[data-r-name]').textContent=r.name; resEl.querySelector('[data-r-note]').textContent=r.note; resEl.querySelector('[data-r-link]').setAttribute('href',r.href); return; }
      var s=steps[state.step]; qEl.textContent=s.q; stepEl.textContent='Step '+(state.step+1)+' of '+steps.length; optsEl.innerHTML='';
      s.opts.forEach(function(o){ var b=document.createElement('button'); b.type='button'; b.className='quiz-opt'; b.textContent=o;
        b.onclick=function(){ state.ans[s.key]=o; state.step++; render(); }; optsEl.appendChild(b); });
    }
    modal.querySelectorAll('[data-quiz-open]').forEach(function(){});
    document.querySelectorAll('[data-quiz-open]').forEach(function(btn){ btn.onclick=function(){ state={step:0,ans:{}}; modal.classList.add('open'); render(); }; });
    modal.querySelectorAll('[data-quiz-close]').forEach(function(b){ b.onclick=function(){ modal.classList.remove('open'); }; });
    modal.querySelector('[data-quiz-retake]').onclick=function(){ state={step:0,ans:{}}; render(); };
  }
  // PDP interactions
  function pdp(){
    if(!document.querySelector('[data-pdp]')) return;
    // thumbs
    var main = document.querySelector('[data-main-img]'), thumbs = document.querySelectorAll('[data-thumb]');
    thumbs.forEach(function(t){ t.onclick=function(){ thumbs.forEach(function(x){x.classList.remove('active');}); t.classList.add('active'); var src=t.getAttribute('data-src'); if(src&&main) main.src=src; }; });
    // sticky buy bar
    var bar = document.querySelector('[data-buybar]');
    if(bar){ window.addEventListener('scroll', function(){ bar.classList.toggle('show', window.pageYOffset>620); }, {passive:true}); }
    // before/after
    var ba = document.querySelector('[data-ba]');
    if(ba){ var before=ba.querySelector('.ba__before'), handle=ba.querySelector('.ba__handle'), dragging=false;
      function set(x){ var r=ba.getBoundingClientRect(); var pos=Math.max(0,Math.min(100,(x-r.left)/r.width*100)); before.style.clipPath='inset(0 '+(100-pos)+'% 0 0)'; handle.style.left=pos+'%'; }
      set(ba.getBoundingClientRect().left + ba.getBoundingClientRect().width/2);
      ba.addEventListener('mousedown', function(e){ dragging=true; set(e.clientX); });
      window.addEventListener('mousemove', function(e){ if(dragging) set(e.clientX); });
      window.addEventListener('mouseup', function(){ dragging=false; });
      ba.addEventListener('touchstart', function(e){ dragging=true; set(e.touches[0].clientX); });
      window.addEventListener('touchmove', function(e){ if(dragging) set(e.touches[0].clientX); });
      window.addEventListener('touchend', function(){ dragging=false; });
    }
  }
  function boot(){ reveal(); parallax(); quiz(); pdp(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
